import { render } from "./bar-chart.vue?vue&type=template&id=63e03fe6"
import script from "./bar-chart.vue?vue&type=script&lang=js"
export * from "./bar-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/charts/bar-chart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63e03fe6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63e03fe6', __exports__)) {
    api.reload('63e03fe6', __exports__)
  }
  
  module.hot.accept("./bar-chart.vue?vue&type=template&id=63e03fe6", () => {
    api.rerender('63e03fe6', render)
  })

}


export default __exports__